import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import { HighlightChangesService } from './highlight-changes.service';
import { Destination } from '@prlw/core/destinations/destination.entity';
import { Modifier } from '@prlw/core/monitor/types/common';

const CLEAR_HIGHLIGHT_DURATION = 30000;

@Directive({
  selector: '[prlwHighlightChanges]',
})
export class HighlightChangesDirective implements AfterViewChecked {
  @Input() public value!: number;
  @Input() public key!: string;
  @Input() public deps!: [Modifier | null, Destination | null];
  private timeout!: ReturnType<typeof setTimeout>;

  constructor(
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    private readonly store: HighlightChangesService,
  ) {}

  public ngAfterViewChecked(): void {
    const previousValue = this.store.getValue(this.key);
    const previousDeps = this.store.getDeps(this.key);
    if (previousValue !== this.value) {
      this.store.saveValue(this.key, this.value, this.deps);
    }

    if (
      previousValue &&
      this.value &&
      previousValue !== this.value &&
      JSON.stringify(previousDeps) === JSON.stringify(this.deps)
    ) {
      this.setHighlight(this.value - previousValue);
    }
  }

  public setHighlight(dynamic: number): void {
    if (dynamic === 0) {
      return;
    }
    if (dynamic > 0) {
      this.setPositiveDynamic();
    }
    if (dynamic < 0) {
      this.setNegativeDynamic();
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(
      () => this.clearHighlight(),
      CLEAR_HIGHLIGHT_DURATION,
    );
  }

  public setPositiveDynamic(): void {
    this.renderer.addClass(this.el.nativeElement, 'highlight-positive-dynamic');
  }

  public setNegativeDynamic(): void {
    this.renderer.addClass(this.el.nativeElement, 'highlight-negative-dynamic');
  }

  public clearHighlight(): void {
    this.renderer.addClass(this.el.nativeElement, 'reset-highlight-dynamic');
  }
}
